import CatchCombination from '../CatchRegistrationModels/CatchCombination';
import { NoteDocuments } from './Documents';

export type NoteStatus = 'open' | 'closed' | 'review' | 'expired';
export type StatusFilter = NoteStatus | 'all';
export interface ReweightingNote {
  id: number;
  landingId: number;
  shipNumber: number;
  shipName: string;
  landedAt: string;
  harbourId: number;
  harbourName: string;
  buyerName: string;
  receiverName: string;
  permitId: number | null;
  permitName: string | null;
  gearId: number;
  gearName: string;
  isClosed: boolean;
  closedAt: string | null;
  dueDate: string | null;
  firstDueDate: string | null;
  hasMissingDeadline: boolean;
  hasActivePermit: boolean;
  hasPendingDeviation: boolean;
  hasDeviation: boolean;
  totalQuantity: number;
  serverDate: string;
  comment: string | null;
  isExpired: boolean;
  canEdit: boolean;
  readOnlyReason: string | null;
  status: NoteStatus;
}
export interface WeightLineInput {
  id: number | null;
  fishStockId: number;
  fishingAreaId: number;
  conditionId: number;
  storageMethodId: number;
  destinyId: number;
  isUnderKilogram: boolean;
  quantity: number;
  unguttedQuantity: number | null;
  declaredIcePercentage: number | null;
  comment: string | null;
}
export interface ReweightingLine extends Omit<WeightLineInput, 'id'> {
  id: number;
  fishStockName: string;
  fishingAreaName: string;
  conditionName: string;
  storageMethodName: string;
  destinyName: string;
  scaleWeight: number;
  dueDate: string | null;
  hasDeviation: boolean;
}
export interface NoteDetail {
  note: ReweightingNote;
  weights: ReweightingLine[];
  originalNoteId: number | null;
  originalWeights: ReweightingLine[];
  version: string;
  documents?: NoteDocuments | null;
}
export interface Worklist {
  items: ReweightingNote[];
  total: number;
  page: number;
  pageSize: number;
  counts: { open: number; closed: number; expired: number; review: number };
}
export interface ReferenceOption { id: number; name: string }
export interface ReweightingReferences {
  fishingStocks: ReferenceOption[];
  fishingAreas: ReferenceOption[];
  conditions: ReferenceOption[];
  storageMethods: ReferenceOption[];
  destinies: ReferenceOption[];
  combinations: CatchCombination[];
}
export interface DeviationPreview {
  hasDeviation: boolean;
  deviationLineIds: number[];
  originalNoteId: number | null;
  originalQuantity: number;
  quantity: number;
  version: string;
}
export interface SubmissionResult { noteId: number; requiresReview: boolean; closedAt: string | null }
export const toLineInput = (line: ReweightingLine): WeightLineInput => ({
  id: line.id, fishStockId: line.fishStockId, fishingAreaId: line.fishingAreaId,
  conditionId: line.conditionId, storageMethodId: line.storageMethodId, destinyId: line.destinyId,
  isUnderKilogram: line.isUnderKilogram, quantity: line.quantity,
  unguttedQuantity: line.unguttedQuantity, declaredIcePercentage: line.declaredIcePercentage,
  comment: line.comment,
});
